export enum AppRoutes {
	Home = '/',
	Payment = '/payment',
	WindcavePayment = '/windcave-payment',
}
